import Api from '@/api'

export default {
  namespaced: true,

  actions: {
    async sendFileShare({ commit }, payload) {
      const body = {
        fileIds: payload.fileIds,
        emails: payload.emails,
      }
      const { data } = await Api.post('multi-file-share', body).catch((err) => {
        throw err
      })
      return data
    },

    async reshareFile({ commit }, payload) {
      const { data } = await Api.post(`file/${payload.fileId}/reshare`, {
        emails: payload.emails,
      }).catch((err) => {
        throw err
      })

      return data
    },

    async revokeFileShareEmail({ commit }, payload) {
      const { data } = await Api.post(
        `file/${payload.fileId}/share-revoke`,
        payload.formData,
      ).catch((err) => {
        throw err
      })

      return data
    },
  },
}
